import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";

import { Button } from "@/components/Button";
import { Input } from "@/components/Input";
import { ErrorState, Spinner } from "@/components/states";
import { usePresets } from "@/hooks/usePresets";
import { useDeletePreset, useSavePreset } from "@/hooks/usePresetsAdmin";

export function Presets() {
  const { data, isLoading, isError } = usePresets();
  const save = useSavePreset();
  const del = useDeletePreset();
  const [key, setKey] = useState("");
  const [label, setLabel] = useState("");
  const [terms, setTerms] = useState("");

  function submit() {
    if (!key.trim() || !label.trim() || !terms.trim()) return;
    save.mutate(
      { key: key.trim(), label: label.trim(), terms },
      {
        onSuccess: () => {
          setKey("");
          setLabel("");
          setTerms("");
        },
      },
    );
  }

  return (
    <main className="mx-auto w-full max-w-3xl px-6 py-6">
      <h1 className="mb-4 text-lg font-semibold text-ink-1">Пресеты</h1>

      <div className="mb-6 space-y-2 rounded-lg border border-line bg-bg-1 p-4">
        <div className="text-sm font-medium text-ink-2">Новый пресет (или измени существующий по тому же ключу)</div>
        <div className="flex flex-wrap gap-2">
          <Input placeholder="ключ (bazi)" value={key} onChange={(e) => setKey(e.target.value)} className="w-40" />
          <Input
            placeholder="название (BaZi 八字)"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            className="min-w-[200px] flex-1"
          />
        </div>
        <Input
          placeholder="термины через запятую: bazi, 八字, 四柱 (до 8)"
          value={terms}
          onChange={(e) => setTerms(e.target.value)}
          className="w-full"
        />
        <Button onClick={submit} disabled={save.isPending}>
          <Plus size={16} /> Сохранить
        </Button>
      </div>

      {isLoading && <Spinner />}
      {isError && <ErrorState>Не удалось загрузить пресеты.</ErrorState>}
      <div className="space-y-2">
        {data?.map((p) => (
          <div
            key={p.key}
            className="flex items-start justify-between gap-3 rounded-lg border border-line bg-bg-1 px-4 py-3"
          >
            <div className="min-w-0">
              <div className="font-medium text-ink-1">
                {p.label} <span className="text-xs text-ink-3">({p.key})</span>
              </div>
              <div className="mt-1 flex flex-wrap gap-1">
                {p.terms.map((t) => (
                  <span key={t} className="rounded bg-bg-2 px-1.5 py-0.5 text-[11px] text-ink-2">
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <div className="flex shrink-0 items-center gap-3">
              <button
                onClick={() => {
                  setKey(p.key);
                  setLabel(p.label);
                  setTerms(p.terms.join(", "));
                }}
                className="text-xs text-ink-3 hover:text-accent"
              >
                изменить
              </button>
              <button
                onClick={() => {
                  if (window.confirm(`Удалить пресет «${p.label}»?`)) del.mutate(p.key);
                }}
                disabled={del.isPending}
                title="Удалить"
                className="text-ink-3 hover:text-err disabled:opacity-50"
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
